import { liquidGlassSurfaceFillSx } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RitualConfig } from '../../helpers/ritual';

interface RatingSelectorProps {
    rating: number | null;
    config: RitualConfig;
    onRatingChange: (rating: number) => void;
}

export const RatingSelector: FC<RatingSelectorProps> = ({ rating, config, onRatingChange }) => {
    const { t } = useTranslation();
    return (
        <>
            <Stack direction="row" justifyContent="space-between" gap={0.75} sx={{ mb: 2 }}>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => {
                    const isSelected = rating === n;

                    return (
                        <Box
                            key={n}
                            onClick={() => onRatingChange(n)}
                            sx={{
                                flex: 1,
                                aspectRatio: '1/1.5',
                                maxWidth: '32px',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                '&:active': {
                                    transform: 'scale(0.95)',
                                },
                                ...(isSelected
                                    ? { backgroundColor: config.bannerBg, border: `2px solid ${config.bannerBg}` }
                                    : { border: '2px solid transparent', ...liquidGlassSurfaceFillSx }),
                            }}
                        >
                            <Text style={{
                                fontSize: '16px',
                                fontWeight: 600,
                                color: isSelected ? 'var(--tg-theme-button-text-color)' : 'var(--tg-theme-text-color)',
                            }}>
                                {n}
                            </Text>
                        </Box>
                    );
                })}
            </Stack>
            <Stack direction="row" justifyContent="space-between">
                <Text style={{ fontSize: '12px', color: 'var(--tg-theme-hint-color)' }}>
                    {t('rating.bad')}
                </Text>
                <Text style={{ fontSize: '12px', color: 'var(--tg-theme-hint-color)' }}>
                    {t('rating.great')}
                </Text>
            </Stack>
        </>
    );
};
